import styled from 'styled-components';

const Container = styled.div`
  width: ${({ width }) => width};
  height: fit-content;
  display: block;
`;

const Header = styled.div`
  width: 100%;
`;

const ContentArea = styled.div`
  width: 100%;
  height: fit-content;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  position: relative;
`;

export { Container, Header, ContentArea };
